// extracted by mini-css-extract-plugin
module.exports = {"container":"SubscriptionItemFlag_container__nnA_p","icon":"SubscriptionItemFlag_icon__8t8fQ","caption":"SubscriptionItemFlag_caption__WA82l"};